import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

export const LoginLink = styled(Link)(
    ({ theme: { fontWeight, palette } }) => css`
        color: ${palette.tertiary.default};
        font-weight: ${fontWeight.bold};
        text-decoration: none;

        &:hover {
            color: ${palette.tertiary.hover};
        }
    `,
);
